export default "<swal #messageSwal [focusConfirm]=\"true\"></swal>"